import { login } from '@/webpublicapi/login'

export default {
  
  en: {
    title: 'Approval Management',
    performancetitle: 'Approval Performance',
    appSsid: 'App',
    repayCurCount: 'repayCurCount',
    preCount: 'preCount',
    repayNormalCount: 'repayNormalCount',
    extendCount: 'extendCount',
    repayOverCount: 'repayOverCount',
    overExtendCount: 'overExtendCount',
    overCount: 'overCount',
    firstOverDueRate: 'firstOverDueRate',
    firstAmountOverDueRate: 'firstAmountOverDueRate',
    aAmountoverDueRate: 'aAmountoverDueRate',
    aoverDueRate: 'aoverDueRate',
    perRepayRate: "perRepayRate",
    repayNormalRate: "repayNormalRate",
    extendCountRate: "extendCountRate",
    repayOverCountRate: "repayOverCountRate",
    overExtendCountRate: "overExtendCountRate",
    curDate: "curDate",
    requestDate: "date",
    colbackRate: 'colbackRate',
    T1colbackRate: 'T1colbackRate',
    T2colbackRate: 'T2colbackRate',
    T3colbackRate: 'T3colbackRate',
    T3OvercolbackRate: 'T3OvercolbackRate',
    period: 'period',
    lastUnSettleCount: 'The number of outstanding transactions from the previous period',
    preFirstRepayRate: 'First overdue (based on the previous period already repaid)',
    preRepayRate: 'Bad debts (based on the previous period repaid)',
    datadt: 'Date',
    fee: 'Cost',
    installs: 'Installation',
    regCount: 'Register',
    subCount: 'Apply for a loan',
    approvalCount: 'Through loan',
    loanCount: 'Loan disbursement',
    irRate: 'Installation - Registration conversion rate',
    rsRate: 'Register - Apply for conversion rate',
    saRate: 'Application - Pass the conversion rate',
    slRate: 'Application - Loan disbursement conversion rate',
    alRate: 'Through - loan conversion rate',
    installFee: 'Installation unit price',
    regFee: 'Registration unit price',
    subFee: 'Loan application unit price',
    approvalFee: 'Through unit price',
    loanFee: 'Unit price of loan disbursement',
    subtotal: 'Subtotal',



    productType: 'Product Type',
    all: 'All',
    mainProduct: 'Main Product',
    multiLoanProduct: 'Multi-Loan Product',
    installmentType: 'Installment Type',
    initial: 'Initial',
    repeatGaid: 'Duplicate Registered GAID',
    gaidRepeatRate: 'GAID Duplicate Rate',
    filteredInstallCount: 'Filtered Installation Count after Duplicate GAID',
    filteredInstallRegRate: 'Filtered Installation Registration Rate after Duplicate GAID',

    bidParticipantNum: 'Number of participants in bidding',
    bidSuccessNum: 'Number of successful bidders',
    registerBidParticipantRate: 'Register - Participate Conversion Rate',
    bidSuccessRate: 'Participate - Success Conversion Rate',
    completeOpenAccountNum: 'Number of completed account opening',
    completeRiskAssessmentNum: 'Number of completed risk assessment',
    rechargeNum: 'Number of recharges',
    logIn: 'Login',
  },
  es: {
    title: 'Quản lý phê duyệt',
    performancetitle: 'Hiệu suất phê duyệt',
    appSsid: 'Ứng dụng',
    repayCurCount: 'Số khoản vay đến hạn phải trả',
    preCount: 'Số khoản trả trước hạn',
    repayNormalCount: 'Số khoản trả đúng hạn trong ngày',
    extendCount: 'Số lần gia hạn',
    repayOverCount: 'Số khoản trả khi đã quá hạn',
    overExtendCount: 'Số lần gia hạn quá hạn',
    overCount: 'Số khoản vẫn chưa trả sau hạn',
    firstOverDueRate: 'Số khoản rơi vào quá hạn lần đầu',
    firstAmountOverDueRate: 'Số tiền của khoản quá hạn lần đầu',
    aoverDueRate: 'Tỷ lệ quá hạn thời gian thực',
    aAmountoverDueRate: 'Tỷ lệ quá hạn thực tế (số tiền)',
    perRepayRate: "Tỷ lệ trả trước hạn",
    repayNormalRate: "Tỷ lệ trả đúng ngày",
    extendCountRate: "Tỷ lệ gia hạn kỳ vay",
    repayOverCountRate: "Tỷ lệ trả sau hạn",
    overExtendCountRate: "Tỷ lệ gia hạn đối với khoản đã quá hạn",
    curDate: "Ngày",
    requestDate: "Ngày",
    colbackRate: 'Tỷ lệ thu hồi',
    T1colbackRate: 'Tỷ lệ thu hồi T1',
    T2colbackRate: 'Tỷ lệ thu hồi T2',
    T3colbackRate: 'Tỷ lệ thu hồi T3',
    T3OvercolbackRate: 'Tỷ lệ thu hồi T3+',
    T4colbackRate: 'Tỷ lệ thu hồi T4',
    T5colbackRate: 'Tỷ lệ thu hồi T5',
    T6colbackRate: 'Tỷ lệ thu hồi T6',
    T7colbackRate: 'Tỷ lệ thu hồi T7',
    T8colbackRate: 'Tỷ lệ thu hồi T8',
    T9colbackRate: 'Tỷ lệ thu hồi T9',
    T10colbackRate: 'Tỷ lệ thu hồi T10',
    T11colbackRate: 'Tỷ lệ thu hồi T11',
    T12colbackRate: 'Tỷ lệ thu hồi T12',
    T13colbackRate: 'Tỷ lệ thu hồi T13',
    T14colbackRate: 'Tỷ lệ thu hồi T14',
    T14OverbackRate: 'Tỷ lệ thu hồi T14+',
    repayCurInCount: 'Số lần vào thu hồi',
    period: 'Kỳ hạn',
    lastUnSettleCount: 'Số khoản từ kỳ trước chưa tất toán',
    preFirstRepayRate: 'Khoản quá hạn lần đầu (theo kỳ đã tất toán)',
    preRepayRate: 'Nợ xấu (tính theo kỳ đã tất toán)',


    datadt: 'Ngày',
    fee: 'Chi phí',
    installs: 'Lượt cài đặt',
    regCount: 'Lượt đăng ký',
    subCount: 'Lượt nộp hồ sơ',
    approvalCount: 'Lượt phê duyệt',
    loanCount: 'Lượt giải ngân',
    irRate: 'Tỷ lệ chuyển đổi Cài đặt → Đăng ký',
    rsRate: 'Tỷ lệ chuyển đổi Đăng ký → Nộp hồ sơ',
    saRate: 'Tỷ lệ chuyển đổi Nộp hồ sơ → Duyệt',
    slRate: 'Tỷ lệ chuyển đổi Nộp hồ sơ → Giải ngân',
    alRate: 'Tỷ lệ chuyển đổi Duyệt - Giải ngân',
    installFee: 'Chi phí cho mỗi lượt cài đặt',
    regFee: 'Chi phí cho mỗi lượt đăng ký',
    subFee: 'Chi phí cho mỗi hồ sơ',
    approvalFee: 'Chi phí cho mỗi lượt được duyệt',
    loanFee: 'ĐChi phí cho mỗi lượt giải ngân',
    subtotal: 'Tổng phụ',

    productType: 'Loại sản phẩm',
    all: 'Tất cả',
    mainProduct: 'Sản phẩm chính',
    multiLoanProduct: 'Sản phẩm vay đa khoản',
    installmentType: 'Loại kỳ hạn',
    initial: 'Ban đầu',
    repeatGaid: 'GAID đã đăng ký trùng lặp',
    gaidRepeatRate: 'Tỷ lệ trùng lặp GAID',
    filteredInstallCount: 'Số cài đặt sau khi lọc GAID trùng lặp',
    filteredInstallRegRate: 'Tỷ lệ đăng ký cài đặt sau khi lọc GAID trùng lặp',

    bidParticipantNum: 'Số người tham gia đầu tư',
    bidSuccessNum: 'Số người đầu tư thành công',
    registerBidParticipantRate: 'Tỉ lệ chuyển đổi từ đăng ký → tham gia đầu tư',
    bidSuccessRate: 'Tỉ lệ chuyển đổi từ tham gia → đầu tư thành công',
    completeOpenAccountNum: 'Số người hoàn tất mở tài khoản',
    completeRiskAssessmentNum: 'Số người hoàn tất đánh giá rủi ro',
    rechargeNum: 'Số người nạp tiền',
    logIn: 'Đăng nhập',
  }
}
